import { useState, useEffect } from 'react';
import { Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkCookieConsent = () => {
      const cookieConsent = localStorage.getItem('cookieConsent');
      const ageVerified = localStorage.getItem('ageVerified');
      
      // Only show cookie popup if age is verified and no cookie consent exists
      if (ageVerified === 'true' && !cookieConsent) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // Check immediately
    checkCookieConsent();

    // Listen for storage changes (when age verification is set)
    const handleStorageChange = () => {
      checkCookieConsent();
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also check periodically in case age verification happens in same tab
    const interval = setInterval(checkCookieConsent, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 max-w-sm w-[calc(100%-2rem)] sm:w-auto bg-regal-gray border-2 border-gray-800 rounded-lg shadow-2xl z-40 p-4 sm:p-6 transform transition-all duration-300 ease-out">
      <div className="flex items-start gap-3">
        <Cookie className="w-5 h-5 sm:w-6 sm:h-6 text-regal-red flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <h3 className="text-base sm:text-lg font-bold text-white mb-2">Cookie Preferences</h3>
          <p className="text-xs sm:text-sm text-gray-300 leading-relaxed mb-3 sm:mb-4">
            We use cookies to enhance your experience, analyze site usage, and assist with our marketing efforts. By clicking "Accept", you consent to our use of cookies.
          </p>
          <div className="flex flex-wrap gap-2 mb-2">
            <button
              onClick={handleAccept}
              className="bg-regal-red hover:bg-red-700 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm font-semibold transition-all"
            >
              Accept
            </button>
            <button
              onClick={handleDecline}
              className="border border-gray-600 hover:border-gray-500 text-gray-300 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm font-semibold transition-all"
            >
              Decline
            </button>
          </div>
          <Link
            to="/cookie-policy"
            data-discover="true"
            className="text-xs text-regal-red hover:text-red-400 inline-block"
          >
            Learn more →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;

